// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__I6cYI","table":"Table_table__MgNb5","table--column-widths":"Table_table--column-widths__vVmdQ"};